import React from 'react';
import { CommissionsDashboard } from './pages/CommissionsDashboard';
export function App() {
  return <CommissionsDashboard data-id="element-0" data-mp="35ctv7gbp4jht" />;
}